import axios from 'axios';

/**
 * Token DOSTEPU do panelu stanowiska (Marcin, 2026-09-23) — wartosc z LINKU kiosku
 * (`https://<instancja>-registration.innerweb.net/?t=<token>`), ktora backend porownuje
 * z ustawieniem rotowanym przez superadmina.
 *
 * 🔒 DWA ROZNE SEKRETY, nie mylic ich ze soba:
 *
 *  1. Sekret KONTENERA (`STATION_TOKEN`, naglowek `X-Station-Token`) — dokladany do kazdego
 *     zadania przez nginx tego kontenera, z env, przy starcie
 *     (devops/docker/dockerfs/entrypoint.sh i konfiguracja nginx obok). NIGDY nie przechodzi
 *     przez `npm run build` i NIGDY nie moze pojawic sie w KODZIE zadnego pliku w `src/` —
 *     pilnuje tego `RegistrationStation.tokenLeak.test.js`, ktoremu TEN plik rowniez podlega.
 *     Bramka bada sam KOD, wiec ostrzezenie moze nazwac sekret po imieniu; wczesniejsza wersja
 *     badala surowy tekst i zmuszala ten akapit do omijania wlasnego tematu
 *     (`[opis-mr-rozjechany-z-bramka]`, kontrola MR !34).
 *  2. Token DOSTEPU (ten modul) — jedzie w adresie, ktory operator wklepuje na kiosku, wiec
 *     przegladarka i tak go zna i widzi w pasku adresu. Wysylanie go z JS NIE JEST wyciekiem:
 *     nie da sie ujawnic czegos, co uzytkownik ma na ekranie. Jest za to BRAMKA: bez niego
 *     backend odmawia, wiec samo dosiegniecie publicznego hosta stanowiska juz nie wystarcza,
 *     zeby uzyc endpointow stanowiska (dziura opisana jako
 *     `[sec.stanowisko-proxy-bez-autoryzacji]` w RegistrationStation.js).
 *
 * Dlatego CALA obsluga tego tokenu siedzi TUTAJ, a nie w RegistrationStation.js: tamten plik
 * ma pozostac wolny od jakiegokolwiek napisu przypominajacego naglowek stanowiska, zeby bramka
 * antywyciekowa dalej dzialala na tekscie zrodla i nie trzeba bylo jej rozmiekczac wyjatkami.
 */

/** Wzgledna sciezka same-origin — nginx tego kontenera proxy'uje ja do backendu instalacji. */
export const STATION_API_BASE = '/szkolenia/webapi/stanowisko';

/** Nazwa parametru w adresie kiosku. MUSI zgadzac sie z `RegistrationStationAccessToken::QUERY_PARAM`. */
export const PARAM_TOKENU = 't';

/** Naglowek, ktorym backend odbiera wartosc. MUSI zgadzac sie z `RegistrationStationAccessToken::HEADER`. */
const NAGLOWEK = 'X-Station-Access-Token';

/**
 * Wartosc `?t=` z BIEZACEGO adresu, czytana przy KAZDYM wywolaniu (nie zapamietywana w module).
 * Dzieki temu podmiana adresu na kiosku dziala od razu po przeladowaniu strony i nie ma stanu,
 * ktory moglby sie rozjechac z tym, co naprawde jest w pasku adresu.
 *
 * Swiadomie NIE zapisujemy tokenu w `localStorage`/`sessionStorage`: kiosk stoi w sekretariacie,
 * a kazda kopia sekretu poza adresem to kolejne miejsce, z ktorego moze wyciec, i kolejne, ktore
 * trzeba by czyscic po rotacji (inaczej po zmianie tokenu ekran dzialalby ze starej kopii i nikt
 * by nie zauwazyl, ze rotacja nic nie dala).
 *
 * @returns {string} token albo pusty string, gdy adres go nie niesie
 */
export const tokenDostepu = () => {
  try {
    return new URLSearchParams(window.location.search).get(PARAM_TOKENU) || '';
  } catch (e) {
    // `URLSearchParams`/`window.location` moga nie istniec w nietypowym srodowisku — brak tokenu
    // znaczy odmowe, nigdy wywalony ekran.
    return '';
  }
};

/*
 * 🟡 `[martwy-eksport-po-poprawce]` (kontrola MR !34). Bylo tu `czyJestTokenDostepu()` —
 * skrot pozwalajacy odmowic BEZ pytania backendu. Po poprawce `[zgodnosc-wstecz-rollout]`
 * nie ma juz zadnego wywolania w kodzie produkcyjnym i celowo go NIE zostawiamy: to gotowy
 * do wklejenia „if" przed zapytaniem, ktory odtworzylby dopiero co naprawiony blad wdrozenia
 * (kiosk bez `?t=` przestaje dzialac, zanim powstanie miejsce, skad wziac nowy adres).
 * O werdykt pyta backend — zawsze.
 */

/** Konfiguracja axiosa z naglowkiem tokenu dostepu. Nigdy nie dokladamy tu sekretu kontenera. */
const konfiguracja = () => ({ headers: { [NAGLOWEK]: tokenDostepu() } });

/**
 * Jawny timeout zapytania BRAMKI (Fibonacci, CLAUDE.md). 🟠 `[ponowienie-bez-oczekiwania]`
 * (kontrola MR !34): backend, ktory nie odrzuca polaczenia tylko WISI, bez tego trzymalby
 * zadanie w nieskonczonosc. Dotyczy wylacznie sprawdzenia dostepu — zadania skanu i zaliczenia
 * maja swoje wlasne zachowanie i tu ich nie ruszamy.
 */
const TIMEOUT_BRAMKI_MS = 8000;

/**
 * POST na endpoint stanowiska. JEDYNY naglowek dokladany z JS to token z adresu; sekret
 * kontenera dokłada nginx po drodze i JS go nie widzi.
 */
export const postStation = (path, body) =>
  axios.post(`${STATION_API_BASE}${path}`, body, konfiguracja());

/** Werdykt bramki. Trzy stany, bo „nie wiem" NIE MOZE udawac zadnego z pozostalych dwoch. */
export const DOSTEP = {
  OK: 'ok',
  ODMOWA: 'odmowa',
  AWARIA: 'awaria',
};

/**
 * Bramka wejsciowa panelu.
 *
 * 🟠 `[access-gate-fail-open]` (kontrola MR !34). Pierwsza wersja zwracala `true` dla KAZDEGO
 * bledu poza 403 — timeout, brak odpowiedzi, 500. Zamiar byl sluszny (chwilowa awaria backendu
 * nie moze wygladac jak „adres nieaktualny" i wysylac operatora po nowy link), ale skutek nie:
 * ekran pokazywal PELNY, normalnie wygladajacy panel, wiec operator zaczynal skanowac ludzi
 * w stanowisko, ktore i tak nic nie zapisze — czyli dokladnie w stan, ktoremu ta bramka ma
 * zapobiegac. Roznica miedzy „zly link" a „backend nie odpowiada" jest dla obslugi kluczowa
 * (pierwsze naprawia administrator, drugie zglasza sie jako awaria), wiec sa to DWA osobne
 * werdykty i dwa osobne ekrany — zaden nie udaje dzialajacego stanowiska.
 */
export const sprawdzDostep = async () => {
  // 🔴 `[zgodnosc-wstecz-rollout]` (kontrola MR !34). Poprzednia wersja odmawiala NATYCHMIAST,
  // bez jednego zapytania, gdy adres nie niosl tokenu — a tak wyglada KAZDY dzisiejszy kiosk,
  // bo token powstaje dopiero w backendzie, ktorego jeszcze nie wdrozono. Obraz wdrozony przed
  // backendem (czyli tak, jak ma isc) pokazywalby wiec „adres nieaktualny" i odsylal operatora
  // po nowy adres do ustawien, KTORYCH JESZCZE NIE MA — skanowanie staloby do czasu wdrozenia
  // backendu i recznej podmiany adresu na kazdym urzadzeniu. Poprzednia poprawka (404) zamknela
  // tylko sciezke „token jest, trasy nie ma" i zostawila te druga otwarta.
  //
  // Dlatego o werdykt pytamy backend ZAWSZE, takze bez tokenu: 404 znaczy „backend bez bramki"
  // i przepuszcza, 403 znaczy „bramka jest, a tego adresu nie wpuszcza" i odmawia. Odmowa bez
  // pytania nie jest juz nigdzie potrzebna — brak tokenu i tak konczy sie 403, gdy bramka
  // istnieje.
  try {
    await axios.get(`${STATION_API_BASE}/dostep`, { ...konfiguracja(), timeout: TIMEOUT_BRAMKI_MS });
    return DOSTEP.OK;
  } catch (e) {
    const status = e?.response?.status;

    if (status === 403) {
      return DOSTEP.ODMOWA;
    }

    // 🔴 `[backward-compatible-rollout-broken]` (kontrola MR !34). 404 na `/dostep` znaczy
    // BACKEND BEZ BRAMKI — instalacja sprzed wdrozenia tokenu dostepu po prostu nie ma tej
    // trasy. Poprzednia wersja liczyla to jako AWARIE, wiec obraz reaktora wdrozony PRZED
    // backendem (a tak wlasnie ma isc wdrozenie, zeby nie bylo okna przestoju) pokazywalby na
    // kiosku „brak lacznosci" i BLOKOWAL skanowanie — dokladna odwrotnosc zgodnosci wstecz,
    // ktora deklarowalem.
    //
    // Przepuszczenie 404 NIE jest rozmiekczeniem bramki: skoro trasy nie ma, to i pozostale
    // endpointy stanowiska tokenu nie sprawdzaja, wiec nie ma czego egzekwowac po stronie
    // ekranu. Gdy backend z bramka wejdzie, ta sama trasa zaczyna oddawac 200/403 i ekran
    // zachowuje sie tak, jak powinien — bez zmiany obrazu.
    if (status === 404) {
      return DOSTEP.OK;
    }

    return DOSTEP.AWARIA;
  }
};
